import { render, staticRenderFns } from "./MouserConfiguratorFooter.vue?vue&type=template&id=71a08919&scoped=true&lang=pug&"
import script from "./MouserConfiguratorFooter.vue?vue&type=script&lang=js&"
export * from "./MouserConfiguratorFooter.vue?vue&type=script&lang=js&"
import style0 from "./MouserConfiguratorFooter.vue?vue&type=style&index=0&id=71a08919&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a08919",
  null
  
)

export default component.exports